export const enum KeyCode {
  Backspace = 8,
  Enter = 13,
  Escape = 27,
  Space = 32,
  ArrowUp = 38,
  ArrowRight = 39,
  ArrowDown = 40,
  ArrowLeft = 37,
  Delete = 46,
}

export const enum Key {
  Tab = 'Tab',
  Esc = 'Escape',
  Space = ' ',
  Enter = 'Enter',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
}
